import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { Observable } from 'rxjs/Observable';

import { Program } from './../../../../../../models/program/program';
import { Group } from './../../../../../../models/program/group';
import { ExistingUser, ExistingUserConflicting } from '../../../../../../models/program/existing-user';
import { NewAndExistingUsers } from '../../../../../../models/program/new-and-existing-users';
import { NewUser } from '../../../../../../models/program/new-user';
import { UserWelcomeMessage } from '../../../../../../models/program/user-welcome-message';

import { ProgramService } from './../../../../../../shared/services/program.service';
import { GroupService } from './../../../../group.service';
import { UserService } from './../../../../user.service';
import { ErrorService } from '../../../../../../shared/services/error.service';
import { SearchService } from '../../../../../../shared/services/search.service';
import { PermissionsService} from '../../../../../../shared/services/permissions.service';

@Component({
  selector: 'app-add-users-to-existing-team',
  templateUrl: './add-users-to-existing-team.component.html',
  styleUrls: ['./add-users-to-existing-team.component.less']
})
export class AddUsersToExistingTeamComponent {
  @Input() programId: number;
  @Input() groupId: number;
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  public invite: FormGroup;
  public newAndExisting: NewAndExistingUsers = [];
  public errors: string[];
  public saving = false;
  public existingInProgram: ExistingUserConflicting[] = [];
  public userBeingCreated = false;
  public sendWelcome = false;
  public welcomeSettings: FormGroup = null;

  constructor(
    private searchService: SearchService,
    private errorService: ErrorService,
    private userService: UserService,
    private groupService: GroupService,
    private _fb: FormBuilder,
    private permissionsService: PermissionsService,
  ) { }

  /**
  * Public Methods
  */

  ngOnInit(): void {
    this.welcomeSettings = this._fb.group({
      subject: this._fb.control(null, Validators.required),
      body: this._fb.control(null, Validators.required)
    });
    this.groupService.getDefaultWelcome(this.programId, this.groupId).subscribe(welcome => {
      this.welcomeSettings.setValue(welcome);
    });
  }

  public addUsers(): void {
    this.saving = true;
    let welcome: UserWelcomeMessage = null;
    if(this.sendWelcome) {
      if(this.welcomeSettings.valid) {
        welcome = this.welcomeSettings.value;
      }
      else {
        welcome = null;
        this.errors = ['Please provide a subject and message.'];
        this.saving = false;
        return;
      }
    }
    this.userService.addGroupUsers(this.programId, this.groupId, this.newAndExisting, welcome).subscribe(res => {
      this.saving = false;
      this.reset.emit(true);
      this.errors = [];
    }, err => {
      this.saving = false;
      // TODO: show error to user
      console.log('unable to move users into this group');
      console.log(err);
      this.errors = this.errorService.messages(err);
    });
  }

  public handleNewAndExisting(updatedExistingAndNew: (ExistingUser | NewUser)[]) {
    this.newAndExisting = updatedExistingAndNew;
    this.updateConflictsAndValidation();
  }

  public updateConflictsAndValidation(): void {
    this.userBeingCreated = this.newAndExisting.filter(user => user.id === -1).length > 0 ? true : false;
    let existingUsersToAdd = this.newAndExisting.filter(user => user.id > 0) as ExistingUser[];
    this.existingInProgram = existingUsersToAdd.filter(existingUserFromArray =>
      existingUserFromArray.groups.some(group => group.program_id === this.programId)
    ).map(existingUserFromArray => {
      return {
        ...existingUserFromArray,
        'conflictingGroup': existingUserFromArray.groups.filter(
          group => group.program_id === this.programId
        )[0]
      } as ExistingUserConflicting;
    });
  }

  public removeConflictingUser(userId: number): void {
    this.newAndExisting = this.newAndExisting.filter(existingUser => existingUser.id !== userId);
    this.updateConflictsAndValidation()
  }

  public setSendWelcome(sendWelcome: boolean): void {
    this.sendWelcome = sendWelcome;
  }

  public get canCreateUsers() {
    return !this.permissionsService.simplifiedSessionManagement;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/users/add-users-to-existing-team/add-users-to-existing-team.component.ts